import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useAuth } from "@/lib/auth";
import { AuthForm } from "./AuthForm";
import { LogoMark } from "./Logo";

export const AuthDialog = () => {
  const { dialog, closeAuth } = useAuth();
  return (
    <Dialog open={dialog.open} onOpenChange={(o) => !o && closeAuth()}>
      <DialogContent data-testid="auth-dialog" className="bg-[#0b0b0d] border-white/10 text-white rounded-[28px] max-w-md">
        <LogoMark className="h-10 w-10" />
        <DialogTitle className="font-display text-2xl font-bold">{dialog.mode === "register" ? "Create your account" : "Sign in to Frame Shift"}</DialogTitle>
        <DialogDescription className="text-slate-400 -mt-2">{dialog.reason || "Track your orders and download your finished images."}</DialogDescription>
        <AuthForm key={dialog.mode + String(dialog.open)} initialMode={dialog.mode} onDone={closeAuth} />
      </DialogContent>
    </Dialog>
  );
};
